<div class="content-wrapper pb-5 credenciales-container">
  <div class="page-title-box d-flex flex-wrap align-items-center justify-content-between mb-4">
    <div>
      <h3 class="page-title m-0 d-flex align-items-center">
        <div class="title-icon-badge mr-3">
          <i class="fas fa-id-badge"></i>
        </div>
        <span>Estadísticas de Credenciales Vistas</span>
      </h3>
      <p class="text-muted small mb-0 mt-1">Consultas de credenciales contra GECROS por período</p>
    </div>
    <a class="btn btn-outline-brand rounded-pill px-4 mt-2 mt-sm-0 d-inline-flex align-items-center font-weight-bold" [routerLink]="['/estadisticas-sistema']">
      <i class="fas fa-arrow-left mr-2"></i> Volver a Estadísticas
    </a>
  </div>

  <div class="card filter-card mb-4 border-0 shadow-sm">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center">
          <i class="fas fa-calendar-alt text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0 text-uppercase tracking-wide text-dark" style="font-size: 0.85rem;">Período de análisis</h6>
        </div>
        <span class="small text-muted" *ngIf="desdeDatosTexto">
          <i class="fas fa-info-circle mr-1"></i>Datos disponibles desde <b>{{ desdeDatosTexto }}</b>
        </span>
      </div>
      <div class="row align-items-end">
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Desde</label>
          <input type="date" class="form-control" [(ngModel)]="filtros.fechaDesde" (change)="aplicarManual()" />
        </div>
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Hasta</label>
          <input type="date" class="form-control" [(ngModel)]="filtros.fechaHasta" (change)="aplicarManual()" />
        </div>
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Agrupar por</label>
          <select class="form-control" [(ngModel)]="granularidad" (change)="onGranularidad()">
            <option value="dia">Día</option>
            <option value="semana">Semana</option>
            <option value="mes">Mes</option>
            <option value="anio">Año</option>
          </select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label d-block">Accesos rápidos</label>
          <div class="btn-group btn-group-sm flex-wrap" role="group">
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'hoy'" [class.btn-outline-brand]="presetActivo !== 'hoy'" (click)="aplicarPreset('hoy')">Hoy</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === '7dias'" [class.btn-outline-brand]="presetActivo !== '7dias'" (click)="aplicarPreset('7dias')">7 días</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === '30dias'" [class.btn-outline-brand]="presetActivo !== '30dias'" (click)="aplicarPreset('30dias')">30 días</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'mes'" [class.btn-outline-brand]="presetActivo !== 'mes'" (click)="aplicarPreset('mes')">Este mes</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'ultimoMes'" [class.btn-outline-brand]="presetActivo !== 'ultimoMes'" (click)="aplicarPreset('ultimoMes')">Último mes completo</button>
            <button type="button" class="btn" [class.btn-brand-primary]="presetActivo === 'todos'" [class.btn-outline-brand]="presetActivo !== 'todos'" (click)="aplicarPreset('todos')">Todos los datos</button>
            <button type="button" class="btn btn-outline-brand" (click)="limpiar()"><i class="fas fa-undo-alt mr-1"></i> Limpiar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="d-flex flex-column justify-content-center align-items-center py-5 my-5">
    <div class="spinner-border text-brand" role="status" style="width: 3.5rem; height: 3.5rem; border-width: 0.25em;">
      <span class="sr-only">Cargando...</span>
    </div>
    <p class="text-muted font-weight-bold mt-3">Cargando estadísticas...</p>
  </div>

  <div *ngIf="!isLoading && errorMsg" class="alert alert-danger text-center py-4">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{ errorMsg }}
    <div class="mt-3">
      <button class="btn btn-brand-primary" (click)="cargar()"><i class="fas fa-redo mr-1"></i> Reintentar</button>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && !errorMsg && data">
    <div class="row mb-4">
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-info">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Vistas en el período</span>
              <div class="kpi-value">{{ data.total | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-eye mr-1"></i> Credenciales consultadas</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-id-badge"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-success">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Promedio por día</span>
              <div class="kpi-value">{{ data.promedioDiario | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-calculator mr-1"></i> Vistas / día</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-calculator"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-primary">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Total histórico</span>
              <div class="kpi-value">{{ data.totalGeneral | formatNumber }}</div>
              <span class="kpi-subtext"><i class="fas fa-database mr-1"></i> Acumulado general</span>
            </div>
            <div class="kpi-icon-wrapper"><i class="fas fa-chart-bar"></i></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card section-card border-0 shadow-sm">
      <div class="card-header bg-transparent d-flex align-items-center">
        <i class="fas fa-chart-bar text-brand mr-2"></i>
        <h6 class="font-weight-bold m-0">Vistas por {{ granularidad === 'anio' ? 'año' : granularidad === 'mes' ? 'mes' : granularidad === 'semana' ? 'semana' : 'día' }}</h6>
      </div>
      <div class="card-body">
        <div style="position: relative; height: 360px;">
          <canvas
            baseChart
            [datasets]="lineData"
            [labels]="lineLabels"
            [options]="lineOptions"
            [colors]="lineColors"
            [legend]="lineLegend"
            [chartType]="lineType"
          ></canvas>
        </div>
      </div>
    </div>

    <div class="card section-card border-0 shadow-sm mt-4">
      <div class="card-header bg-transparent d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="fas fa-clock text-brand mr-2"></i>
          <h6 class="font-weight-bold m-0">Vistas por hora</h6>
        </div>
        <span class="badge badge-light border text-dark">Hora pico: {{ horaPicoTexto() }}</span>
      </div>
      <div class="card-body">
        <div style="position: relative; height: 360px;">
          <canvas
            baseChart
            [datasets]="horaData"
            [labels]="horaLabels"
            [options]="horaOptions"
            [colors]="horaColors"
            [chartType]="horaType"
          ></canvas>
        </div>
      </div>
    </div>
  </ng-container>
</div>
